/**
 * A PLAN SET ASIDE, OPENED AS ITS OWN CARD (owner, 23 Oct 2026: "See it anyway" opened the year-by-year
 * projections, not the plan). The note says why the plan was set aside; its link opens the plan's card
 * right beneath it, the same card the leading plans have, with Explain this, What could go wrong and Choose.
 * The plan is never promoted: it shows only when asked for, and "Hide it" folds it away again.
 */
import React, { useState } from 'react';

interface Props {
    /** The note, given the link to place at the end of its sentence. */
    note: (link: React.ReactNode) => React.ReactNode;
    /** The plan's card, drawn the way the module draws every card. */
    renderCard: () => React.ReactNode;
    /** The note's box; the module's own amber-rail style. */
    className: string;
    linkClassName?: string;
    testId: string;
}

const SetAsideReveal = ({ note, renderCard, className, linkClassName = 'font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4', testId }: Props) => {
    const [open, setOpen] = useState(false);
    const link = (
        <button type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open} className={linkClassName} data-testid={`${testId}-toggle`}>
            {open ? 'Hide it' : 'See it anyway'}
        </button>
    );
    return (
        <>
            <div className={className} data-testid={testId}>{note(link)}</div>
            {open && <div data-testid={`${testId}-card`}>{renderCard()}</div>}
        </>
    );
};

export default SetAsideReveal;
